import { convLocalToIsoString } from '@awp/helpers/utilsReact';

const selectFieldsToMap = [
  'observer',
  'blaster',
  'assistantBlaster',
  'avalanche_path',
  'avalanche_area',
  'avalanche_program',
  'avalanche_target',
];
const measuredFieldsToMap = ['aval_mass_toe_dist', 'aval_rd_cover_length'];
const measuredFields = ['aval_mass_toe_dist_measured', 'aval_rd_cover_length_measured'];
const checkboxFields = ['aval_is_avalanche_success', 'aval_is_detonation_failure', 'aval_is_outside']; //only checkbox and not for property

//when this is changed, this should be synced with server code AvalancheService.cs => _propertiesSelectFieldsToMap
const propertiesSelectFieldsToMap = [
  'aval_trig_type_cd',
  'aval_start_dir_cd',
  'aval_start_loc_cd',
  'aval_size_cd',
  'aval_type_cd',
  'aval_start_zone_wtr_cd',
  'aval_deposit_wtr_cd',
  'aval_terminus_cd',
  'aval_release_lvl_cd',
  'aval_cntrl_type_cd',
];

const propertiesFieldsToMap = [
  'aval_slab_width',
  'aval_slab_thknes',
  'aval_deposit_length',
  'aval_deposit_width',
  'aval_deposit_dpth',
  'aval_dust_toe_dist',
  'aval_rd_dpth_max',
  'aval_rd_dpth',
  'aval_trig_dist',
  'aval_cntrl_chrg',
  'aval_cntrl_cast_booster',
  'aval_cntrl_fuse_length',
  'aval_cntrl_fuse_no',
];

export const mapFormToServerFormat = (formData) => {
  let mutatedFormData = { ...formData };

  const keys = Object.keys(formData);

  keys
    .filter((item) => selectFieldsToMap.includes(item))
    .forEach((f) => {
      const optionValue = mutatedFormData[f];
      const value = optionValue?.value;
      mutatedFormData = {
        ...mutatedFormData,
        [f]: value,
        internal: { ...mutatedFormData.internal, [f]: optionValue },
      };
    });
  keys
    .filter((item) => checkboxFields.includes(item))
    .forEach((f) => {
      const isMeasured = mutatedFormData[f] || false;
      mutatedFormData = {
        ...mutatedFormData,
        [f]: isMeasured === true ? 'Y' : 'N',
        internal: { ...mutatedFormData.internal, [f]: isMeasured },
      };
    });

  keys
    .filter((item) => propertiesSelectFieldsToMap.includes(item))
    .forEach((f) => {
      const optionValue = mutatedFormData[f];
      const value = optionValue?.value;
      mutatedFormData = {
        ...mutatedFormData,
        properties: { ...mutatedFormData.properties, [f]: value },
        internal: { ...mutatedFormData.internal, [f]: optionValue },
      };
      delete mutatedFormData[f];
    });

  keys
    .filter((item) => propertiesFieldsToMap.includes(item))
    .forEach((f) => {
      const value = mutatedFormData[f];
      mutatedFormData = {
        ...mutatedFormData,
        properties: { ...mutatedFormData.properties, [f]: value },
      };
      delete mutatedFormData[f];
    });

  keys
    .filter((item) => measuredFieldsToMap.includes(item))
    .forEach((f) => {
      const value = mutatedFormData[f];
      const isMeasured = mutatedFormData[`${f}_measured`] || false;
      mutatedFormData = {
        ...mutatedFormData,
        properties: { ...mutatedFormData.properties, [f]: { value: value, measured: isMeasured === true ? 'Y' : 'N' } },
        internal: { ...mutatedFormData.internal, [f]: value, [`${f}_measured`]: isMeasured },
      };
      delete mutatedFormData[f];
      delete mutatedFormData[`${f}_measured`];
    });

  // handle specific transforms
  const timestamp = mutatedFormData['timestamp'] ? mutatedFormData['timestamp'] : new Date();
  mutatedFormData = {
    ...mutatedFormData,
    timestamp: convLocalToIsoString(new Date(timestamp)),
    internal: { ...mutatedFormData.internal, timestamp: timestamp },
  };

  const isIncident = mutatedFormData['incident']
    ? mutatedFormData['incident'] === 'true'
      ? 'Y'
      : 'N'
    : mutatedFormData['incident'];
  mutatedFormData = {
    ...mutatedFormData,
    incident: isIncident,
  };
  return mutatedFormData;
};

export const mapServerToFormFormat = (serverData) => {
  if (!serverData.internal) {
    //return mapServerToFormFormatNoInternal(serverData);
  }

  let mutatedServerData = { ...serverData };

  const internalFieldsToMap = selectFieldsToMap
    .concat(propertiesSelectFieldsToMap)
    .concat(measuredFieldsToMap)
    .concat(measuredFields)
    .concat(checkboxFields);

  Object.keys(serverData.internal || {})
    .filter((item) => internalFieldsToMap.includes(item))
    .forEach((f) => {
      const value = mutatedServerData.internal[f];
      mutatedServerData = {
        ...mutatedServerData,
        [f]: value,
      };
    });

  Object.keys(serverData.properties || {})
    .filter((item) => propertiesFieldsToMap.includes(item))
    .forEach((f) => {
      const value = mutatedServerData.properties[f];
      mutatedServerData = {
        ...mutatedServerData,
        [f]: value,
      };
    });

  const timestamp = mutatedServerData.internal['timestamp'];
  mutatedServerData = {
    ...mutatedServerData,
    timestamp: timestamp,
  };

  const isIncident = mutatedServerData['incident']
    ? mutatedServerData['incident'] === 'Y'
      ? 'true'
      : 'false'
    : mutatedServerData['incident'];
  mutatedServerData = {
    ...mutatedServerData,
    incident: isIncident,
  };

  delete mutatedServerData.internal;
  delete mutatedServerData.properties;

  //console.log('after server mutation', mutatedServerData);
  return mutatedServerData;
};

//TODO: this function will be used to map the server JSON that wasn't
//	created with the UI
// - How do we re-create the dropdown options?
export const mapServerToFormFormatNoInternal = (serverData) => {
  let mutatedServerData = { ...serverData };
  //console.log('before server mutation', mutatedServerData);
};

export const mapObject = (object, isTouched) => {
  const touchedItems = Object.keys(object)
    .map((o) => o)
    .reduce((acc, item, idx) => {
      if (item === 'aval_mass_toe_dist') {
        return { ...acc, [item]: isTouched, aval_rd_dpth: true, aval_rd_dpth_max: true, aval_rd_cover_length: true };
      } else {
        return { ...acc, [item]: isTouched };
      }
    }, {});

  //console.log(touchedItems);
  return touchedItems;
};

export const DegreesToRadians = (value) => {
  return (value * Math.PI) / 180.0;
};

export const RadiansToDegrees = (value) => {
  return (value / Math.PI) * 180.0;
};

export const HaversineDistance = (lat1, long1, lat2, long2) => {
  const _m2km = 1.609344;

  //determine the distance between the 2 coordinate points using solution of spherical triangles https://en.wikipedia.org/wiki/Great-circle_distance
  // ER = arccos[sin LatA * sin LatB + cos LatA * cos LatB * cos (LngA - LngB)]
  // angle = sin b * sin c + cos b * cos c * cos A
  // b (dLat1) is latitude (to radians) of point 1
  // c (dLat2) is latidude (to radians) of point 2
  // A (theta) is difference in meridians of the longtitude of both points (to radians)
  const dLat1 = DegreesToRadians(lat1);
  const dLat2 = DegreesToRadians(lat2);
  const theta = DegreesToRadians(long1 - long2);
  const angle = Math.sin(dLat1) * Math.sin(dLat2) + Math.cos(dLat1) * Math.cos(dLat2) * Math.cos(theta);

  //inverse cosine the angle to determine the earths radius
  let distance = Math.acos(angle);
  //radians back to degress
  distance = RadiansToDegrees(distance);
  //one min of degrees = 1.1515 miles, degress * 1 hr (60 mins) * 1 mile (1.1515)
  distance = distance * 60 * 1.1515;
  //convert to KM, or N (nautical miles) 0.8684
  distance = distance * _m2km;

  return distance;
};
